module.exports = __webpack_public_path__ + "img/super.85f30a5e.jpeg";